export enum TabIndices {
  HomePage = 0,
  Profile = 1,
  SubscriptionList = 2,
  Invoices = 3,
}
